<template>
  <CFooter :fixed="false">
    <div>
      <a href="/terms-conditions">Terms & Conditions / Refund Policy</a>
      <br />
      <a href="https://www.soldiernet.co.uk" target="_blank">SoldierNET</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} SoldierNET Ltd.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
